import React, { useEffect } from 'react';
import {
  Box,
  Heading,
  Grid,
  Text,
  Flex,
  Image,
  useToast,
} from '@chakra-ui/core';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getFavories, deleteFavory } from '../redux/actions/restAction';
import { FaEuroSign } from 'react-icons/fa';
import { AiFillDelete } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';

import { ClearError } from '../redux/actions/authAction';
import Head from '../util/Head';

function Favories({ ClearError, deleteFavory, getFavories, favs, auth }) {
  const history = useHistory();

  const toast = useToast();
  useEffect(() => {
    ClearError();

    if (!auth.data && !auth.loading) {
      history.push('/');
    } else {
      getFavories();
    }
  }, []);

  const handelDelete = async id => {
    await deleteFavory(id);
    toast({
      position: 'top-right',
      title: 'Favory Deleted',
      description: 'Favory Delete Successfuly',
      status: 'success',
      duration: 4000,
      isClosable: true,
    });
  };

  return (
    <Box
      mt="100px"
      mr={['20px', '50px', '50px', '50px']}
      ml={['20px', '50px', '50px', '50px']}
      mb="100px"
      p="20px"
    >
      <Head title="Favories"></Head>

      {auth.data && !auth.loading && (
        <>
          <Box m="6" textAlign="center">
            <Heading> Vos Favoris</Heading>
          </Box>
          <Box rounded="20px" bg="white">
            {favs &&
              favs.map(fav => {
                return (
                  <Box key={fav.favory_id} bg="gray.100">
                    <Grid
                      p="3"
                      gridTemplateColumns={[
                        ' 1fr ',
                        '0.1fr 1fr ',
                        '0.1fr 1fr ',
                        '0.1fr 1fr ',
                      ]}
                    >
                      <Link to={`restaurant/${fav.restaurant_id}`}>
                        <Image
                          h="100px"
                          w="100px"
                          cursor="pointer"
                          mb={['10px', '0', '0', '0']}
                          mt={['10px', '0', '0', '0']}
                          rounded="5px"
                          src={`${process.env.REACT_APP_API}/storage/${fav.image}`}
                          alt=""
                        />
                      </Link>
                      <Flex justifyContent="space-between">
                        <Box width="90%">
                          <Link to={`restaurant/${fav.restaurant_id}`}>
                            <Box color="black" cursor="pointer">
                              <Heading size="lg">{fav.name}</Heading>
                              <Text>{fav.adress}</Text>
                              <Box
                                fontSize="16px"
                                display="flex"
                                dir="column"
                                alignItems="flex-end"
                              >
                                <FaEuroSign></FaEuroSign>
                                <FaEuroSign></FaEuroSign>
                                <FaEuroSign></FaEuroSign>
                              </Box>
                            </Box>
                          </Link>
                        </Box>

                        <AiFillDelete
                          onClick={() => handelDelete(fav.favory_id)}
                          className="favory-delete-icon"
                        ></AiFillDelete>
                      </Flex>
                    </Grid>
                  </Box>
                );
              })}
          </Box>
        </>
      )}
    </Box>
  );
}

const mapStateToProps = state => {
  return {
    favs: state.rest.favs,
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFavories: () => dispatch(getFavories()),
    deleteFavory: id => dispatch(deleteFavory(id)),
    ClearError: () => dispatch(ClearError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Favories);
